// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__mPwfa","right":"styles_right__3bNoW"};